function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import clsx from 'clsx';
import { Dropdown } from '@isyc-react/design/overlays';
import { OverlayContainer } from "../../../../base";
import { InputDateCalendarIcon } from "./input-date-calendar-icon.component";
import "./input-date-overlay.style.scss";
export const InputDateOverlay = props => {
  const {
    readOnly,
    disabled,
    error,
    dateFormat,
    OverlayTrigger = InputDateCalendarIcon,
    showSelectionBorder = false,
    children
  } = props;
  const [show, setShow] = React.useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: "input-date-overlay-container"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    alignEnd: true,
    show: show,
    onToggle: nextShow => setShow(nextShow),
    drop: 'down'
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, null, (toggleProps, meta) => /*#__PURE__*/React.createElement("div", _extends({}, toggleProps, {
    onClick: () => {
      if (!disabled && !readOnly) meta.toggle(!show);
    },
    className: clsx('input-date-overlay-button', {
      'border-bottom border-primary border-2 lh-sm': showSelectionBorder
    }),
    tabIndex: 0,
    role: "button"
  }), /*#__PURE__*/React.createElement(OverlayTrigger, {
    error: error,
    disabled: disabled,
    onlyTime: !dateFormat.includes('Y')
  }))), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    flip: false,
    offset: [15, 15]
  }, (menuProps, meta) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayContainer, _extends({}, menuProps, {
    disableScrollbars: true,
    show: meta.show
  }), children)))));
};